var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 15.0003H12.3337C11.98 15.0003 11.6409 14.8598 11.3908 14.6098C11.1408 14.3598 11.0003 14.0206 11.0003 13.667V10.3337C11.0003 10.1568 10.9301 9.98728 10.8051 9.86225C10.68 9.73723 10.5105 9.66699 10.3337 9.66699H9.66699",
    fill: "#1429B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 15.0003H12.3337C11.98 15.0003 11.6409 14.8598 11.3908 14.6098C11.1408 14.3598 11.0003 14.0206 11.0003 13.667V10.3337C11.0003 10.1568 10.9301 9.98728 10.8051 9.86225C10.68 9.73723 10.5105 9.66699 10.3337 9.66699H9.66699",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6663 6.99967C10.5779 6.99967 10.4932 6.96456 10.4306 6.90204C10.3681 6.83953 10.333 6.75475 10.333 6.66634C10.333 6.57794 10.3681 6.49315 10.4306 6.43064C10.4932 6.36813 10.5779 6.33301 10.6663 6.33301",
    stroke: "#1429B8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.667 6.99967C10.7554 6.99967 10.8402 6.96456 10.9027 6.90204C10.9652 6.83953 11.0003 6.75475 11.0003 6.66634C11.0003 6.57794 10.9652 6.49315 10.9027 6.43064C10.8402 6.36813 10.7554 6.33301 10.667 6.33301",
    stroke: "#1429B8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11 21C16.5227 21 21 16.5227 21 11C21 5.47733 16.5227 1 11 1C5.47733 1 1 5.47733 1 11C1 16.5227 5.47733 21 11 21Z",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.b8e11cbe2535515311a834eb33f2abf7.svg";
export { ForwardRef as ReactComponent };